import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { useDealerAccountInfo } from "../../../stores/hooks/useDealerAccountInfo";
import { useIsLoggedOn } from "../../../stores/hooks/useIsLoggedOn";
import { selectComparePricing } from "./selectComparePricing";

export const useShouldRenderPricing = (part: TirePartItem): boolean => {
  const { marketMinimum = false } = selectComparePricing(
    part.partPricing.primaryPart.price
  );
  const { dealerEnableMembershipPricing } = useDealerAccountInfo();
  const isLoggedOn = useIsLoggedOn();
  return !(
    marketMinimum &&
    dealerEnableMembershipPricing === "1" &&
    !isLoggedOn
  );
};
